import { navigateTo } from 'nuxt/app'
import { jwtDecode } from 'jwt-decode'
import type { UserJWT } from '@/types/jwt'
import { useUserStore } from '~/store/user'
import { defineNuxtPlugin, isEmpty } from '#imports'

export default defineNuxtPlugin((nuxtApp: any) => {
  const api = $fetch.create({
    async onRequest({ options }) {
      const { userToken, logout } = useUserStore()

      // If token is expired, forward user to login again
      if (userToken) {
        const { exp } = jwtDecode<UserJWT>(userToken)
        const exp2Date = new Date((exp || 0) * 1000)
        const now = new Date(Date.now())
        if (exp2Date.getTime() - now.getTime() < 0) {
          logout()
          // Redirect to /time-out on expiration
          await nuxtApp.runWithContext(() => navigateTo('/time-out'))
        }

        if (!isEmpty(options.headers)) {
          return
        }
        options.headers ||= new Headers()
        options.headers.set('x-authorization-obo', `Bearer ${userToken}`)
      }
    },
    async onResponseError({ response }) {
      if (response.status === 401) {
        useUserStore().logout()
        // Keep redirecting to /login for general 401 errors
        await nuxtApp.runWithContext(() => navigateTo('/login'))
      }
    },
  })

  // Expose to useNuxtApp().$api
  return {
    provide: {
      api,
    },
  }
})
